import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GoodToKnow } from '../../../../components/HotelDetailsOverlay/components/RatingSection/components/GoodToKnow/index.js';
import { RelevantNow } from '../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/index.js';
import { Reviews } from '../../../../components/HotelDetailsOverlay/components/RatingSection/components/Reviews/index.js';
import { Summary } from '../../../../components/HotelDetailsOverlay/components/RatingSection/components/Summary/index.js';
import { TRAVELLER_TYPE_ALL } from '../../../../components/HotelDetailsOverlay/models.js';
import { Stack } from '../../../../primitives/index.js';
import { SPACING_XLARGE } from '../../../../utils/spacingLegacy.js';
export const RatingSection = ({
  data: {
    score,
    scoreDescription,
    reviewsCount,
    goodToKnow,
    reviews = [],
    relevantNow,
    summaryText
  }
}) => {
  const reviewCategoryAll = reviews.find(reviewCategory => reviewCategory.travellerType === TRAVELLER_TYPE_ALL);
  return _jsxs(Stack, {
    spacing: SPACING_XLARGE,
    children: [_jsx(Summary, {
      score: score,
      scoreDescription: scoreDescription,
      reviewsCount: reviewsCount,
      reviewCategories: reviewCategoryAll?.categories
    }), _jsx(GoodToKnow, {
      statements: goodToKnow
    }), _jsx(Reviews, {
      reviews: reviews,
      summaryText: summaryText
    }), _jsx(RelevantNow, {
      data: relevantNow
    })]
  });
};